import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";

type State = {
  IdAcaoQualidade: number;
  centroDeCusto: number[],
  centroDeCustoLista: CentroCustoDropDown[] | undefined,

};


type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setCentroDeCusto: SetFunction<number[]>,
  setCentroDeCustoLista: SetFunction<CentroCustoDropDown[]>,
};


export const initialFiltersValues: State = {
  IdAcaoQualidade: 0,
  centroDeCusto: [],
  centroDeCustoLista: undefined,
};

export const useAcoesPreventivasFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  setCentroDeCusto: (vfn) => SetFunctionImpl(set, 'centroDeCusto', vfn),
  setCentroDeCustoLista: (vfn) => SetFunctionImpl(set, 'centroDeCustoLista', vfn),
  clearFilters: () => set(initialFiltersValues),

}));